import type { SVGProps } from 'react';

export const ArrowUp = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m11.25 8.1-3.325 3.325a.669.669 0 0 1-.525.225.72.72 0 0 1-.525-.225.641.641 0 0 1-.225-.5c0-.217.075-.4.225-.55l4.5-4.5A.861.861 0 0 1 12 5.6c.233 0 .442.092.625.275l4.5 4.5a.71.71 0 0 1 .2.525.602.602 0 0 1-.2.525.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225L12.75 8.1v8.8c0 .217-.075.4-.225.55a.71.71 0 0 1-.525.2.798.798 0 0 1-.55-.2.798.798 0 0 1-.2-.55V8.1Z" />
    </svg>
  );
};
